module.exports = __webpack_public_path__ + "img/WorkSans-Black.a580eed.svg";